module.exports = __webpack_public_path__ + "static/CardOfDarkness4-27585177c2bc9504d811bb56214f54bb.webp";